export default "__VITE_ASSET__CXvBzO7v__"